// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "泵与风机",
      "tec": "关多娇刘维岐",
      "week": "1,3,5-8周",
      "add": "教学楼D座513能动AISEC"
    },
    {
      "sub": "电机与拖动",
      "tec": "申爱兵",
      "week": "1-3,5-9周",
      "add": "教学楼B座417能动"
    },
    [
      {
        "sub": "机械设计基础",
        "tec": "关萌",
        "week": "1-3,5-13周",
        "add": "教学楼D座424能动AISEC"
      },
      {
        "sub": "劳动与创造",
        "tec": "许琳",
        "week": "4周",
        "add": "教学楼B座220能动"
      }
    ],
    {
      "sub": "劳动与创造",
      "tec": "许琳",
      "week": "4周",
      "add": "教学楼B座220能动"
    },
    {
      "sub": "国家安全教育",
      "tec": "周彩虹",
      "week": "7-10周",
      "add": "教学楼C座308教务"
    }
  ],
  "2": [
    {
      "sub": "创新思维训练",
      "tec": "包妍",
      "week": "1-3,5-10周",
      "add": "教学楼D座423信息AISEC"
    },
    {
      "sub": "传热学",
      "tec": "卫运钢",
      "week": "1-3,5-13周",
      "add": "教学楼B座417能动"
    },
    {
      "sub": "毛泽东思想和中国特色社会主义理论体系概论",
      "tec": "张洪涛",
      "week": "1-3,5,7-10周",
      "add": "教学楼A座118电力"
    },
    0,
    0
  ],
  "3": [
    [
      {
        "sub": "电机与拖动",
        "tec": "申爱兵",
        "week": "1-3,5-9周",
        "add": "教学楼B座323能动"
      },
      {
        "sub": "传热学",
        "tec": "卫运钢",
        "week": "10-13周",
        "add": "教学楼B座323能动"
      }
    ],
    {
      "sub": "泵与风机",
      "tec": "关多娇刘维岐",
      "week": "1,3,5-8周",
      "add": "教学楼D座514能动AISEC"
    },
    0,
    0,
    {
      "sub": "国家安全教育",
      "tec": "周彩虹",
      "week": "7-10周",
      "add": "教学楼C座308教务"
    }
  ],
  "4": [
    {
      "sub": "热工检测技术",
      "tec": "孙卓伦",
      "week": "1-3,5-9周",
      "add": "教学楼B座321能动"
    },
    {
      "sub": "机械设计基础",
      "tec": "关萌",
      "week": "1-3,5-13周",
      "add": "教学楼D座425能动AISEC"
    },
    [
      {
        "sub": "毛泽东思想和中国特色社会主义理论体系概论",
        "tec": "张洪涛",
        "week": "1-3,5,7-10周",
        "add": "教学楼C座113教务"
      },
      {
        "sub": "劳动与创造",
        "tec": "许琳",
        "week": "4周",
        "add": "教学楼D座513能动AISEC"
      }
    ],
    {
      "sub": "劳动与创造",
      "tec": "许琳",
      "week": "4周",
      "add": "教学楼D座513能动AISEC"
    },
    0
  ],
  "5": [
    {
      "sub": "创新思维训练",
      "tec": "包妍",
      "week": "1,3,5-9周",
      "add": "教学楼D座514能动AISEC"
    },
    0,
    {
      "sub": "传热学",
      "tec": "卫运钢",
      "week": "1-3,5-13周",
      "add": "教学楼D座514能动AISEC"
    },
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
